import { Eye, EyeOff, RefreshCw } from 'lucide-react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';

export function HostPasswordControl({ password, revealed, onToggle, onGenerate }: {
  password: string;
  revealed: boolean;
  onToggle: () => void;
  onGenerate: () => void;
}) {
  if (!password) {
    return <div className="host-password-unavailable">
      <span>A senha não está disponível nesta sessão.</span>
      <Button type="button" variant="secondary" onClick={onGenerate}><RefreshCw size={15} /> Gerar nova senha</Button>
    </div>;
  }
  return <div className="host-password-field">
    <Input aria-label="Senha da sala" type={revealed ? 'text' : 'password'} value={password} readOnly autoComplete="off" />
    <Button type="button" variant="ghost" className="icon-button" aria-label={revealed ? 'Ocultar senha' : 'Mostrar senha'} title={revealed ? 'Ocultar senha' : 'Mostrar senha'} onClick={onToggle}>
      {revealed ? <EyeOff size={18} /> : <Eye size={18} />}
    </Button>
  </div>;
}
